export type ApiResponse = {
  success: boolean
  message?: string
}

type HasToString = {
  toString(): string
}

export function paramsToQuery<T extends Record<string, HasToString>>(
  params: T
): string {
  const query = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      query.set(key, value.join(','))
    } else {
      query.set(key, value.toString())
    }
  })

  return `?${query.toString()}`
}
